// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.book-list-container-parent {
  position: absolute;
  top: 80px;
  left: 220px;
  width: calc(100% - 220px);
  height: calc(100% - 125px);
  overflow: visible;
}
.book-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: 0px;
  left: 220px;
  width: calc(100% - 220px);
}
.book-list-header-right {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.book-list-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  -webkit-user-select: text;
          user-select: text;
}

.booklist-shelf-list {
  width: 169px;
  height: 31px;
  opacity: 1;
  box-sizing: border-box;
  margin-left: 16px;
  font-size: 15px;
  line-height: 31px;
  border-radius: 5px;
  cursor: pointer;
}
.delete-shelf-icon {
  cursor: pointer;
  margin-left: 20px;
}
.icon-cover {
  font-weight: 500;
}
.booklist-shelf-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.booklist-manage-container {
  cursor: pointer;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}
.book-manage-title {
  font-size: 15px;
  font-weight: 500;
  padding: 6px 10px;
  border-radius: 5px;
}
.book-list-page-navigator {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  margin-left: 10px;
}
.book-list-total-page {
  margin-left: 25px;
  /* width: 50px; */
  height: 40px;
  margin: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.book-list-prev-page {
  cursor: pointer;
  margin-right: 10px;
}
.book-list-next-page {
  cursor: pointer;
  margin-left: 10px;
}
.book-list-page-input {
  width: 50px;
  height: 30px;
  text-align: center;
  border: 1px solid #d9d9d9;
  background-color: transparent;
  border-radius: 5px;
  margin: 0 10px;
}
.book-list-page-container {
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/containers/lists/bookList/booklist.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".book-list-container-parent {\n  position: absolute;\n  top: 80px;\n  left: 220px;\n  width: calc(100% - 220px);\n  height: calc(100% - 125px);\n  overflow: visible;\n}\n.book-list-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: absolute;\n  bottom: 0px;\n  left: 220px;\n  width: calc(100% - 220px);\n}\n.book-list-header-right {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.book-list-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  user-select: text;\n}\n\n.booklist-shelf-list {\n  width: 169px;\n  height: 31px;\n  opacity: 1;\n  box-sizing: border-box;\n  margin-left: 16px;\n  font-size: 15px;\n  line-height: 31px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.delete-shelf-icon {\n  cursor: pointer;\n  margin-left: 20px;\n}\n.icon-cover {\n  font-weight: 500;\n}\n.booklist-shelf-container {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.booklist-manage-container {\n  cursor: pointer;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n.book-manage-title {\n  font-size: 15px;\n  font-weight: 500;\n  padding: 6px 10px;\n  border-radius: 5px;\n}\n.book-list-page-navigator {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 5px;\n  margin-left: 10px;\n}\n.book-list-total-page {\n  margin-left: 25px;\n  /* width: 50px; */\n  height: 40px;\n  margin: 0 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.book-list-prev-page {\n  cursor: pointer;\n  margin-right: 10px;\n}\n.book-list-next-page {\n  cursor: pointer;\n  margin-left: 10px;\n}\n.book-list-page-input {\n  width: 50px;\n  height: 30px;\n  text-align: center;\n  border: 1px solid #d9d9d9;\n  background-color: transparent;\n  border-radius: 5px;\n  margin: 0 10px;\n}\n.book-list-page-container {\n  display: flex;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
